import React, { useEffect, useRef, useState } from "react";
import { Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import { markaterLogin } from "../../store/marketersSlice";

function TeamLeaderLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [, forceUpdate] = useState();
  const dispatch = useDispatch();
  const [creditial, setCreditional] = useState({
    phone: "",
    password: "",
  });

  useEffect(() => {
    Cookies.remove("markter_id");
    Cookies.remove("markter_role");
  }, []);

  const handelInputChange = (event) => {
    const { name, value } = event.target;
    setCreditional((prevInputs) => ({ ...prevInputs, [name]: value }));
  };

  const senToLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(markaterLogin(creditial))
      .unwrap()
      .then((res) => {
        console.log(res);
        if (res.isTeamLeader) {
          Cookies.set("markter_role", "teamleader");
          Cookies.set("markter_id", res.id);
          Cookies.set("user_role", 4);
          toast.success(`تم تسجيل الدخول بنجاح`);
          setTimeout(() => {
            navigate("/teamleader/dashboard");
            setLoading(false);
            window.location.reload();
          }, 1500);
        } else {
          toast.error("هذا ليس حساب مدير فريق");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.data);
        setLoading(false);
      });
  };

  return (
    <>
      <ToastContainer theme="colored" />
      {loading ? <Loading open={true} /> : null}
      <div className="login_page">
        <img
          className="wavelogin"
          src={`${process.env.PUBLIC_URL}/images/wavelogin.svg`}
          alt=""
        />
        <Container maxWidth="xxl">
          <div className="login_form">
            <h5>تسجيل دخول مدير الفريق</h5>
            {/* <div className="logo">
                <img src={`${process.env.PUBLIC_URL}/images/logo.svg`} alt="" />
              </div> */}
            <form action="" onSubmit={senToLogin}>
              <div className="form-group">
                <label htmlFor="">رقم الهاتف</label>
                <input
                  name="phone"
                  value={creditial.phone}
                  type="text"
                  className="form-control"
                  placeholder="0****"
                  onChange={handelInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="">كلمه المرور</label>
                <input
                  name="password"
                  value={creditial.password}
                  type="password"
                  className="form-control"
                  placeholder="**********"
                  onChange={handelInputChange}
                />
              </div>
              <div className="btn_submit">
                <button className="btn">تسجيل الدخول</button>
              </div>
            </form>
          </div>
        </Container>
      </div>
    </>
  );
}

export default TeamLeaderLogin;
